import Swal from "sweetalert2";

export default {
  namespaced: true,
  state: {
    data: [],
    box: null,
    isLoading: false,
    isSaving: false,
  },
  mutations: {
    SET_STATE: (state, obj) => {
      state[`${obj.key}`] = obj.value;
    },
  },
  actions: {
    create: function (context, data) {
      context.commit("SET_STATE", { key: "isSaving", value: true });
      let vm = this;
      return new Promise(function (resolve, reject) {
        vm.$http
          .post(`patients/${data.patient_id}/custom-boxes`, data)
          .then((res) => {
            Swal.fire({
              title: "",
              text: "New box added successfully",
              icon: "success",
            });
            context.commit("SET_STATE", { key: "isSaving", value: false });
            context.dispatch("get", { patient_id: data.patient_id });
            return resolve(res.data);
          })
          .catch((err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "",
                text: (err.data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            context.commit("SET_STATE", { key: "isSaving", value: false });
            return reject(err);
          });
      });
    },
    update: function (context, data) {
      context.commit("SET_STATE", { key: "isSaving", value: true });
      let vm = this;
      return new Promise(function (resolve, reject) {
        vm.$http
          .put(`patients/${data.patient_id}/custom-boxes/${data.id}`, data)
          .then((res) => {
            Swal.fire({
              title: "",
              text: "Box details updated successfully",
              icon: "success",
            });
            context.commit("SET_STATE", { key: "isSaving", value: false });
            context.dispatch("get", { patient_id: data.patient_id });
            return resolve(res.data);
          })
          .catch((err) => {
            context.commit("SET_STATE", { key: "isSaving", value: false });
            if (!err.accessDenied) {
              Swal.fire({
                title: "",
                text: (err.data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            return reject(err);
          });
      });
    },

    get: function (context, data) {
      let vm = this;
      context.commit("SET_STATE", { key: "isLoading", value: true });
      return new Promise(function (resolve) {
        vm.$http
          .get(`patients/${data.patient_id}/custom-boxes`)
          .then((res) => {
            if (res.status == 200) {
              context.commit("SET_STATE", {
                key: "data",
                value: res.data.data || res.data || [],
              });
            }
            context.commit("SET_STATE", { key: "isLoading", value: false });
            resolve(res.data.data || res.data || []);
          })
          .catch((err) => {
            context.commit("SET_STATE", { key: "isLoading", value: false });
            context.commit("SET_STATE", { key: "data", value: [] });
            if (!err.accessDenied) {
              console.error("Error loading boxes:", err);
            }
            resolve([]);
          });
      });
    },

    delete: function (ctx, data) {
      return new Promise((resolve, reject) => {
        ctx.commit("SET_STATE", { key: "isSaving", value: true });
        this.$http
          .delete(`patients/${data.patient_id}/custom-boxes/${data.id}`)
          .then(() => {
            Swal.fire({
              title: "",
              text: "Box deleted successfully",
              icon: "success",
            });
            ctx.commit("SET_STATE", { key: "isSaving", value: false });
            ctx.dispatch("get", { patient_id: data.patient_id });
            resolve(true);
          })
          .catch((err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "",
                text: (err.data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            ctx.commit("SET_STATE", { key: "isSaving", value: false });
            reject(err);
          });
      });
    },
  },
};
